import axios from "@/widgets/shared/utils/axios-instance";
import {entityIdsOf, entityMapOf} from "@/widgets/shared/utils/entity-utils";
import {
  isSessionOverlapping, isWomenInTechCareerDayI, isWomenInTechCareerDayII,
  isWomenInTechSoftSkillFirst,
  isWomenInTechSoftSkillSecond,
  isWomenInTechTechSkills
} from "@/widgets/shared/utils";

export function state() {
  return {
    ids: [],
    sessions: {},
  };
}

export const mutations = {
  setSessions(state, sessions) {
    state.ids = entityIdsOf(sessions);
    state.sessions = entityMapOf(sessions);
  },

  clearSessions(state) {
    state.ids = [];
    state.sessions = [];
  },

  addSession(state, session) {
    state.sessions[session.id] = session;
    state.ids = [...state.ids, session.id];
  },

  removeSession(state, sessionId) {
    delete state.sessions[sessionId];
    state.sessions = {...state.sessions};
    state.ids = state.ids.filter(id => id !== sessionId);
  },
};

export const actions = {
  async loadSchedule({commit}, eventId) {
    await axios
      .get(`events/${eventId}/attendance/my_sessions`)
      .then(result => commit("setSessions", result.data))
      .catch(err => commit("setSessions", []));
  },

  async addSessionToSchedule({commit, rootState, dispatch, getters}, session) {
    const mySessions = getters["allSessions"];
    if(rootState.eventId === 1234) {
      if(!mySessions) {
        throw new Error("Content not loaded, please try again.");
      } else {
        isSessionOverlapping(session, mySessions);
      }
    }
    const body = {
      attendances: [
        {
          action_type: "insert",
          agenda_session_id: session.id,
          updated_at: new Date().toISOString(),
        },
      ],
    };
    const res = await axios.post(`events/${rootState.eventId}/attendance/agenda_sessions`, body);
    const updatedSchedule = res.data;

    commit("setSessions", updatedSchedule);
    dispatch(
      "agendaSessionAttendees/loadAttendeesFromSession",
      {
        agendaSessionId: session.id,
        force: true,
      },
      {root: true}
    );
    if(isWomenInTechSoftSkillFirst(session.id)) {
      commit(
        "lpNotifications/showSuccessNotification",
        {
          title: session.name,
          message: "Gotowe! Zarejestrowałaś się na te warsztaty, do zobaczenia wkrótce! Pamiętaj aby w drugiej połowie dnia wybrać Targi Kariery II ;)",
        },
        { root: true }
      );
    } else if(isWomenInTechSoftSkillSecond(session.id)) {
      commit(
        "lpNotifications/showSuccessNotification",
        {
          title: session.name,
          message: "Gotowe! Zarejestrowałaś się na te warsztaty, do zobaczenia wkrótce! Pamiętaj aby w pierwszej połowie dnia wybrać Targi Kariery I ;)",
        },
        { root: true }
      );
    } else if(isWomenInTechTechSkills(session)) {
      commit(
        "lpNotifications/showSuccessNotification",
        {
          title: session.name,
          message: "Gotowe! Zarejestrowałaś się na te warsztaty, do zobaczenia wkrótce!",
        },
        { root: true }
      );
    }else if(isWomenInTechCareerDayI(session.id)) {
      commit(
        "lpNotifications/showSuccessNotification",
        {
          title: session.name,
          message: "Gotowe! Zarejestrowałaś się na Targi Kariery I, do zobaczenia wkrótce! Pamiętaj aby w drugiej połowie dnia wybrać warsztaty ;)",
        },
        { root: true }
      );
    } else if(isWomenInTechCareerDayII(session.id)) {
      commit(
        "lpNotifications/showSuccessNotification",
        {
          title: session.name,
          message: "Gotowe! Zarejestrowałaś się na Targi Kariery II, do zobaczenia wkrótce! Pamiętaj aby w pierwszej połowie dnia wybrać warsztaty ;)",
        },
        { root: true }
      );
    }
  },

  async removeSessionFromSchedule({commit, rootState, dispatch}, session) {
    const body = {
      attendances: [
        {
          action_type: "delete",
          agenda_session_id: session.id,
          updated_at: new Date().toISOString(),
        },
      ],
    };
    const res = await axios.post(`events/${rootState.eventId}/attendance/agenda_sessions`, body);
    const updatedSchedule = res.data;

    commit("setSessions", updatedSchedule);
    dispatch(
      "agendaSessionAttendees/loadAttendeesFromSession",
      {
        agendaSessionId: session.id,
        force: true,
      },
      {root: true}
    );

    if(isWomenInTechSoftSkillFirst(session.id) || isWomenInTechSoftSkillSecond(session.id)  || isWomenInTechTechSkills(session) ) {
      commit(
        "lpNotifications/showSuccessNotification",
        {
          title: session.name,
          message: "Zostałaś wyrejestrowana z tych warsztatów. Jeśli zmienisz zdanie, śpiesz się, potem może nie być miejsc! :)",
        },
        { root: true }
      );
    } else if(isWomenInTechCareerDayI(session.id)) {
      commit(
        "lpNotifications/showSuccessNotification",
        {
          title: session.name,
          message: "Zostałaś wyrejestrowana z Targów Kariery I Jeśli zmienisz zdanie, śpiesz się, potem może nie być miejsc! :)",
        },
        { root: true }
      );
    } else if(isWomenInTechCareerDayII(session.id)) {
      commit(
        "lpNotifications/showSuccessNotification",
        {
          title: session.name,
          message: "Zostałaś wyrejestrowana z Targów Kariery II Jeśli zmienisz zdanie, śpiesz się, potem może nie być miejsc! :)",
        },
        { root: true }
      );
    }
  },
};

export const getters = {
  sessionById: state => id => state.sessions[id],

  allSessions(state, getters) {
    return state.ids.map(getters.sessionById);
  },

  visibleSessions(state, getters) {
    // eslint-disable-next-line prettier/prettier
    return dayId =>
      getters["allSessions"].filter(
        session => session.agenda_session_day.id === dayId
      );
  },

  isAttendingSession: state => session => {
    return state.ids.filter(id => id === session.id).length > 0;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

